import * as React from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  IconButton,
  TextField,
  TextareaAutosize,
  Tooltip,
  Typography,
} from "@mui/material";
import Logo from "../assets/Logo.png";
import secureLocalStorage from "react-secure-storage";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import InputLabel from "@mui/material/InputLabel";
import NumberToWords from "number-to-words";
import MenuItem from "@mui/material/MenuItem";
import { useSelector } from "react-redux";
import Select from "@mui/material/Select";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";
import { ref, uploadBytes } from "firebase/storage";
import { imageDb } from "../Firebase/Config";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import API from "../Api/api";
function numberToWords(number) {
  const units = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
  ];
  const teens = [
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];
  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  if (number === 0) {
    return "zero";
  }

  function convert(number) {
    let words = "";

    if (number >= 1000000000) {
      words += convert(Math.floor(number / 1000000000)) + " billion, ";
      number %= 1000000000;
    }

    if (number >= 1000000) {
      words += convert(Math.floor(number / 1000000)) + " million, ";
      number %= 1000000;
    }

    if (number >= 1000) {
      words += convert(Math.floor(number / 1000)) + " thousand, ";
      number %= 1000;
    }

    if (number >= 100) {
      words += convert(Math.floor(number / 100)) + " hundred ";
      number %= 100;
    }

    if (number > 0) {
      if (words !== "") {
        words += "and ";
      }

      if (number < 10) {
        words += units[number] + " ";
      } else if (number < 20) {
        words += teens[number - 10] + " ";
        number = 0; // Skip further processing for teens
      } else {
        words += tens[Math.floor(number / 10)] + " ";
        number %= 10;
        if (number > 0) {
          words += units[number] + " ";
          number = 0; // Skip further processing for units
        }
      }
    }

    return words.trim();
  }

  const words = convert(number);
  return words;
}
function generateRandomCode(length) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let code = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    code += characters[randomIndex];
  }

  return code;
}
export default function PrepareAdvice() {
  const [img, setImg] = React.useState("");

  const fileInputRef = React.useRef();

  const handleFileSelection = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) {
      alert("Please select a file");
      return;
    }

    // Check if the file type is PDF or Excel
    if (
      selectedFile.type === "application/pdf" ||
      selectedFile.type === "application/vnd.ms-excel" ||
      selectedFile.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setImg(selectedFile);
      console.log("Selected file:", selectedFile);
    } else {
      alert("Only PDF or Excel files are allowed");
    }
  };

  const handleIconClick = () => {
    fileInputRef.current.click(); // Programmatically trigger the file input
  };

  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const location = useSelector((state) => state.location);

  const locationCode = location
    ? location.filter((loc) => loc.location === user?.results.branch)
    : "";

  let [adviceData, setAdviceData] = React.useState({
    code: "",
    status: "",
    receiving_branch: "",
    branch: user.results.branch,
    received: "",
    description: "",
    amount: "",
    submitted_by: user.results.firstName + " " + user.results.lastName,
    submitter_position: user.results.position || "",
    amount_in_words: "",
    date: "",
    attached_file: "",
    filename: "",
  });
  adviceData.received = user.results.branch === "head office" ? "to" : "from";
  adviceData.receiving_branch =
    user.results.branch === "head office"
      ? adviceData.receiving_branch
      : "head office";

  const amountFirst = Math.floor(adviceData.amount);
  const amountInWords = numberToWords(amountFirst);
  const decimalValue = (adviceData.amount % 1).toFixed(2).split(".")[1];
  const amountInWord =
    amountFirst > 0
      ? amountInWords + " Ghana cedis"
      : "" +
        (decimalValue * 1 > 0
          ? `, ${NumberToWords.toWords(decimalValue)} Ghana pesewas only`
          : "only");

  adviceData.amount_in_words = amountInWord;
  adviceData.code = locationCode
    ? `BRB/AD/${locationCode[0].code.toUpperCase()}/${generateRandomCode(8)}`
    : `BRB/AD/${locationCode[0].code.toUpperCase()}/${generateRandomCode(8)}`;
  adviceData.attached_file = img ? "true" : "false";

  const mimeType = img.type;
  let extent;

  if (mimeType === "application/pdf") {
    extent = "pdf";
  } else if (
    mimeType ===
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ) {
    extent = "xlsx";
  } else if (mimeType === "image/jpeg") {
    extent = "jpg";
  } else if (mimeType === "image/png") {
    extent = "png";
  } else {
    extent = "unknown"; // Default if MIME type is unrecognized
  }
  adviceData.filename = img
    ? adviceData.code.replace(/\//g, "-") + "-details." + extent
    : "";
  const handleChange = (event) => {
    setAdviceData({ ...adviceData, receiving_branch: event.target.value });
  };
  const handleUpload = () => {
    if (!img) {
      return;
    }

    // Determine the file extension based on the MIME type
    const mimeType = img.type;
    let fileExtension;

    if (mimeType === "application/pdf") {
      fileExtension = "pdf";
    } else if (
      mimeType ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      fileExtension = "xlsx";
    } else {
      fileExtension = "unknown"; // Default if MIME type is unrecognized
    }
    // Create the file reference with the determined file extension
    const fileRef = ref(
      imageDb,
      `files/${adviceData.code.replace(/\//g, "-")}-details.${fileExtension}`
    );

    const metadata = {
      contentType: mimeType, // Use the file's MIME type
    };

    // Upload the file with the correct extension
    uploadBytes(fileRef, img, metadata)
      .then(() => {
        toast.success("File successfully attached");
        setImg(""); // Clear the file input after successful upload
      })
      .catch((error) => {
        toast.error("Error attaching file");
      });
  };

  const sendAdviceData = async () => {
    if (
      adviceData.amount &&
      adviceData.status &&
      adviceData.description &&
      adviceData.receiving_branch &&
      adviceData.date
    ) {
      let creatingId;
      try {
        creatingId = toast.loading("submitting data...");
        await API.post("/api/v1/company-advice", adviceData);
        handleUpload();
        toast.remove(creatingId);
        toast.success("data submitted");
        setAdviceData({
          code: "",
          status: "",
          receiving_branch: "",
          branch: user.results.branch,
          received: "",
          description: "",
          amount: "",
          submitted_by: user.results.firstName + " " + user.results.lastName,
          submitter_position: user.results.position || "",
          amount_in_words: "",
          date: "",
          attached_file: "",
        });
      } catch (error) {
        toast.remove(creatingId);
        toast.error(error.message);
      }
    } else {
      toast.error("Please fill all required fields");
    }
  };
  let notManipulate;

  if (user.results.e_advice === "Read Only") {
    notManipulate = true;
  } else {
    notManipulate = false;
  }
  return (
    <div>
      <Helmet title='New Advice | Advice' />
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        marginBottom={"10px"}
        alignItems={"center"}>
        <img width={60} height={"auto"} src={Logo} alt='logo' />

        <Typography style={{ fontSize: "18px" }}>
          Bosome Freho Rural Bank PLC
        </Typography>
        <Typography>
          <strong style={{ textDecoration: "underline" }}>
            INTERBRANCH TRANSFER VOUCHER
          </strong>
        </Typography>
      </Box>

      <Container>
        <Box
          backgroundColor='#e4e4e5'
          padding={"5px"}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}>
          <FormControl>
            <FormLabel required id='demo-row-radio-buttons-group-label'>
              <strong>Status</strong>
            </FormLabel>
            <RadioGroup
              value={adviceData.status}
              onChange={(e) =>
                setAdviceData({ ...adviceData, status: e.target.value })
              }
              row
              aria-labelledby='demo-row-radio-buttons-group-label'
              name='row-radio-buttons-group'>
              <FormControlLabel
                value='credit'
                control={<Radio />}
                label='Credit'
              />
              <FormControlLabel
                value='debit'
                control={<Radio />}
                label='Debit'
              />
            </RadioGroup>
          </FormControl>
          <Typography
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}>
            {user.results.branch === "head office" ? (
              <FormControl size='small' style={{ width: "150px" }} fullWidth>
                <InputLabel id='demo-simple-select-label'>To</InputLabel>
                <Select
                  required
                  labelId='demo-simple-select-label'
                  id='demo-simple-select'
                  value={adviceData.receiving_branch}
                  label='Location'
                  onChange={handleChange}>
                  {location.map((loc) => (
                    <MenuItem key={loc._id} value={loc.location}>
                      {loc.location}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <Typography>
                <strong>To:</strong> Head Office
              </Typography>
            )}
          </Typography>
          <Typography>
            <strong>BRANCH</strong>: {user.results.branch}
          </Typography>
          <Typography
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}>
            <TextField
              required
              type='date'
              label='Date'
              size='small'
              value={adviceData.date}
              onChange={(e) =>
                setAdviceData({ ...adviceData, date: e.target.value })
              }
              InputLabelProps={{ shrink: true }}
            />
          </Typography>
        </Box>
        <Divider />
        <Box display={"flex"} flexDirection={"column"}>
          <TextareaAutosize
            required
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              fontSize: "20px",
            }}
            value={adviceData.description}
            onChange={(e) =>
              setAdviceData({ ...adviceData, description: e.target.value })
            }
            minRows={8}
            cols={120}
            placeholder='description'
          />
          <TextField
            type='number'
            placeholder='Amount'
            required
            value={adviceData.amount}
            onChange={(e) =>
              setAdviceData({ ...adviceData, amount: e.target.value })
            }
            size='small'
            label='Amount'
            style={{ width: "300px" }}
          />
        </Box>
        {adviceData.amount && (
          <Typography>
            <strong>Amount in words</strong>:
            <em>
              {amountFirst && Number(amountFirst) > 0
                ? `${amountInWords} Ghana cedis`
                : ""}
              {decimalValue > 0 ? "," : ""}
              {decimalValue > 0
                ? `${NumberToWords.toWords(decimalValue)} Ghana pesewa${
                    decimalValue > 1 ? "s only" : " only"
                  }`
                : ""}
            </em>
          </Typography>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "start",
          }}>
          <Button
            disabled={notManipulate}
            onClick={sendAdviceData}
            style={{ marginTop: "10px" }}
            size='small'
            variant='contained'>
            submit
          </Button>{" "}
          <div style={{ marginTop: "8px" }}>
            <input
              type='file'
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileSelection}
            />
            {/* <button onClick={handleUpload}>Upload</button> */}
            <Tooltip placement='top' title={<span>attach file</span>}>
              <IconButton onClick={handleIconClick}>
                <AttachFileIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        {img && (
          <p style={{ fontWeight: "normal", fontSize: "14px" }}>
            Attached file: {img.name}
          </p>
        )}
      </Container>
    </div>
  );
}
